import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY, DEFAULTS } from "common/config";
import { COMMON_JS } from "common/scripts";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/labels";

import { ApiMasters } from "apihandlers//masters/masters";

const ApiMastersHandler = new ApiMasters();

const Customers = (props: any) => {
  const { setDashMenu } = props;
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiMastersHandler.getCustomers(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCustomers:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "organizationName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CUSTOMER_NAME,
      width: "20%",
    },
    {
      key: "organizationPan",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PAN_NO,
      width: "10%",
    },
    {
      key: "organizationMobile1",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MOBILE_NO,
      width: "15%",
    },
    {
      key: "organizationContactPerson",
      name: LABELS.CONTACT_PERSON,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "organizationAddress",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ADDRESS,
      width: "15%",
    },
    {
      key: "organizationGst",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.GSTIN,
      width: "10%",
    },
    {
      key: "activeStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "10%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRecord = () => {
    const organizationName = (
      document.getElementById("organizationName") as HTMLInputElement
    ).value.trim();
    const organizationPan = (
      document.getElementById("organizationPan") as HTMLInputElement
    ).value.trim();
    const organizationMobile1 = (
      document.getElementById("organizationMobile1") as HTMLInputElement
    ).value.trim();
    const organizationContactPerson = (
      document.getElementById("organizationContactPerson") as HTMLInputElement
    ).value.trim();
    const organizationAddress = (
      document.getElementById("organizationAddress") as HTMLInputElement
    ).value.trim();
    const organizationGst = (
      document.getElementById("organizationGst") as HTMLInputElement
    ).value.trim();
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations
    // if (!organizationMobile1) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!organizationContactPerson) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!organizationName) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!selectBtnValue) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }

    let errors = [];
    if (organizationName == "") {
      errors.push({
        id: "organizationName",
        msg:
          "<span class='bold'>" +
          LABELS.CUSTOMER_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (organizationMobile1 == "") {
      errors.push({
        id: "organizationPan",
        msg:
          "<span class='bold'>" +
          LABELS.MOBILE_NO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (organizationContactPerson == "") {
      errors.push({
        id: "organizationContactPerson",
        msg:
          "<span class='bold'>" +
          LABELS.CONTACT_PERSON +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!active) {
      errors.push({
        id: "activeStatus",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      organizationName,
      organizationPan,
      organizationMobile1,
      organizationContactPerson,
      organizationAddress,
      organizationGst,
      activeStatus: selectBtnValue.toString(),
    };
    setIsSubmit(true);
    ApiMastersHandler.manageCustomer(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.CUSTOMER}</li>
        </ul>
        <h4>{TITLES.CUSTOMER}</h4>
        <p className="SubTitles">{SUB_TITLES.CUSTOMER}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.CUSTOMER}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.CUSTOMER}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.CUSTOMER + " : " + selectedRow.organizationName
              : "Add New " + LABELS.CUSTOMER
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>
              {LABELS.CUSTOMER_NAME} {<span className="red">{" *"}</span>}
            </label>

            <TxtBox
              id={"organizationName"}
              placeholder={LABELS.CUSTOMER_NAME}
              defaultValue={selectedRow.organizationName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label>{LABELS.PAN_NO}</label>
            <TxtBox
              id={"organizationPan"}
              placeholder={LABELS.PAN_NO}
              defaultValue={selectedRow.organizationPan}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.MOBILE_NO} {<span className="red">{" *"}</span>}
            </label>

            <TxtBox
              id={"organizationMobile1"}
              placeholder={LABELS.MOBILE_NO}
              defaultValue={selectedRow.organizationMobile1}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.CONTACT_PERSON} {<span className="red">{" *"}</span>}
            </label>

            <TxtBox
              id={"organizationContactPerson"}
              placeholder={LABELS.CONTACT_PERSON}
              defaultValue={selectedRow.organizationContactPerson}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label>{LABELS.ADDRESS}</label>
            <TxtBox
              id={"organizationAddress"}
              placeholder={LABELS.ADDRESS}
              defaultValue={selectedRow.organizationAddress}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label>{LABELS.GSTIN}</label>
            <TxtBox
              id={"organizationGst"}
              placeholder={LABELS.GSTIN}
              defaultValue={selectedRow.organizationGst}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.ACTIVE_STATUS} {<span className="red">*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "activeYes",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "activeNo",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>
          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
                // loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Customers);
